export default "__VITE_ASSET__3c61a99d__"